import { useRouter } from 'next/navigation';
import { useAppDispatch } from '@/lib/hooks';
import { setUnitId } from '@/lib/slices/unit-slice';
import { setSubunitId } from '@/lib/slices/subunit-slice';
import { setActivityId, setActivityName, setActivityType } from '@/lib/slices/activity-slice';
import { ActivityData, ActivityType, SubunitData, UnitId } from 'course-types';
import { LessonStateCookie } from 'lesson-types';
import ActiveLessonCacheService from '@/services/storage/active-lesson-cache-service';

interface UseSetActivityOptions {
  subunit?: SubunitData & { id: string };
  unitName?: string;
  unitId?: UnitId | string;
  courseName?: string;
  courseId?: string;
}

export function useSetActivity(options: UseSetActivityOptions = {}) {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const setActivity = (
    activity: ActivityData & {
      description?: string;
      url?: string;
      subunit_id?: string;
      unit_id?: string;
    },
  ) => {
    // Set Redux state
    dispatch(setSubunitId(activity.subunit_id ?? options.subunit?.id ?? undefined));
    dispatch(setUnitId(activity.unit_id ?? options.unitId ?? undefined));
    dispatch(setActivityId(activity.id));
    dispatch(setActivityType(activity.type as ActivityType));
    dispatch(setActivityName(activity.name));

    // Create lesson cookie
    const lessonCookie: LessonStateCookie = {
      activityName: activity.name,
      activityDescription: activity.description ?? '',
      activityURL: activity.url,
      activityId: activity.id,
      activityType: activity.type as ActivityType,
      subunitName: options.subunit?.name ?? '',
      subunitId: options.subunit?.id ?? '',
      unitName: options.unitName ?? '',
      unitId: options.unitId as any,
      courseName: options.courseName ?? '',
      courseId: options.courseId as any,
    };

    ActiveLessonCacheService.setLessonStateCookie(lessonCookie);

    // Navigate to lesson page
    router.push('/student/lesson');
  };

  return setActivity;
}
